<script setup lang="ts">
const { to, color } = defineProps({
	to: {
		type: String,
		required: true
	},
	color: {
		type: String,
		required: false,
		default: "secondary"
	}
})

// External URLs open in a new tab; in-app routes stay in the current
// tab so notification/breadcrumb-style clicks navigate normally.
const isExternal = computed(() => /^(https?:|mailto:|tel:)/i.test(to))
</script>

<template>
	<NuxtLink :class="`text-${color} hover:underline-${color}`" class="decoration-underline" :to="to"
		:target="isExternal ? '_blank' : undefined"
		:rel="isExternal ? 'noopener noreferrer' : undefined">
		<slot />
	</NuxtLink>
</template>
